define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi",
	"csi/heading/_base",
	"csi/heading/Attribute",
	"csi/heading/RendererStoreMixin",
	"csi/html",
	"csi/widget/CheckedMultiSelectDropdown",
	"csi/xml"
], function(declare, _, csi, csiHeading, Attribute, RendererStoreMixin, html, CheckedMultiSelectDropdown, xml) {

	// FIX: Container should not inherit from RendererStoreMixin - it should be moved to RefContainer instead (what about StringContainer with Selection format?)

	return csiHeading.containerRendererConstructor = declare([Attribute, RendererStoreMixin], {
		// Boolean: indicates if container values should be sorted
		//bSort: false,

		canLink: function() {
			// summary: indicates if content can act as anchor
			return false;
		},

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: pass to renBase
			return this.renBase ? this.renBase.formatValue(value, fmt) : value;
		},

		formatValueForFiltering: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: return formatted text for filter values
			return this._getTextValues(ctx, h, value);
		},

		getDefaultValue: function(/*Heading*/h) {
			// summary: return default value for heading
			if (this.renBase) {
				return this.renBase.getDefaultValue(h);
			}

			var type = h.getAttrType();
			return type ? xml.attributeTypeGetDefaultValue(xml.attributeTypeGetBase(type)) : null;
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: for container attributes with no index:
			// 	1) counts of blank vs. non-blank make no sense, so set omitBlankCounts to true
			//  2) filtering is done per item in container, so set type to item type
			var qs;

			if (this.renBase) {
				qs = this.renBase.getQuerySpec(ctx, h, spec);
			} else {
				qs = this.inherited(arguments);
			}

			if (qs && ((qs.id == xml.FILTER_LOCALIZED_NAME) || (qs.index == null))) {
				qs.omitBlankCounts = qs.notSortable = true;
				qs.ops = (qs.type == xml.ATTR_STRING) ? csiHeading.QUERY_OPS.stringcontainer : csiHeading.QUERY_OPS.container;
			}

			return qs;
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*Widget*/editNode) {
			// summary: separate string into tags
			return editNode.get("externalValue") || editNode.get("value");
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: create store for enumeration values and select control to edit
			if (params.value == null) {
				params.value = _.toArray(this._getValue(ctx, h));
			}

			if (params.store == null) {
				params.store = this.getStore(ctx, h, params.value);
			}

			if (params.defaultDisplayValue == null) {
				params.defaultDisplayValue = "Select";
			}

			params.searchAttr = params.store.labelProperty;
			params.excludeValues = [xml.VALUE_BLANK];

			// FIX: temporary code - multi-select is not supposed to modify array that is passed in,
			// but currently seems to be a problem with that in _setValueAttr. For now, copy array.
			if (_.isArray(params.value)) {
				params.value = [].concat(params.value);
			}

			return new CheckedMultiSelectDropdown(params);
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render using innerHTML to support line breaks
			var value = this.toValue(ctx, h);
			if (value) {
				html.multiLineText(refNode, value);
				return true;
			}

			return false;
		},

		toSortValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: sorting not supported for containers
			return null;
		},

		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return attribute value for heading based on context
			var value = this._getValue(ctx, h);

			if (_.isEmpty(value)) {
				return "";
			}

			var textValues = this._getTextValues(ctx, h, value);
			var sep = this._getSeparator(h) || " ";

			// sort textValues by corresponding sortValues (if any)
			if (this.bSort) {
				var sortValues = this._getSortValues(ctx, h, value, textValues);
				if (sortValues) {
					textValues = csi.sortByArray(textValues, sortValues);
				}
			}

			// compose formatted values into string
			return _.reduce(textValues, function(memo, v) {
				return (v == null) ? memo : (memo + (memo ? sep : "") + v);
			}, "");
		},

		_getAction: function() {
			// summary: editing is not supported
			return null;
		},

		_getCSS: function(/*String*/type, /*String?*/format) {
			// summary: add additional class for container attributes
			return this.inherited(arguments) + " attrContainer";
		},

		_getSeparator: function(/*Heading*/h) {
			// summary: return actual separator based on heading configuration
			return (h.m_separator == null) ? ", " : h.m_separator;
		},

		_getSortValues: function(/*Context*/ctx, /*Heading*/h, /*Any*/value, /*String[]*/textValues) {
			// summary: return array of sort values for container values
			if (this._toSortValue) {
				return _.map(value, this._toSortValue, this.renBase);
			}

			return null;
		},

		_getTextValues: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: return array of formatted values for container values
			var fmt = this._getFormat(ctx, h);

			return _.map(value, function(v) {
				return this.formatValue(v, fmt);
			}, this.renBase);
		},

		_toFilterValue: function(/*Context*/ctx, /*Heading*/h, /*Any*/value) {
			// summary: return array of filter values
			return _.isArray(value) ? value : _.values(value);
		}
	});
});